var map = {
	"./a1.jpg": "Bgca",
	"./a2.jpg": "9PgW",
	"./a3.jpg": "UJ2A",
	"./a4.jpg": "hX+f",
	"./b1.jpg": "0Aft",
	"./b2.jpg": "YZBI",
	"./b3.jpg": "BFTK",
	"./b4.jpg": "2jlV",
	"./c1.jpg": "6wFg",
	"./c2.jpg": "OtTi",
	"./c3.jpg": "23nB",
	"./c4.jpg": "cKgu",
	"./d1.jpg": "yIMO",
	"./d2.jpg": "NsOA",
	"./e1.jpg": "JDq9",
	"./e2.jpg": "IQPI",
	"./f1.jpg": "/pUg",
	"./f2.jpg": "hyVs",
	"./f3.jpg": "BqBs",
	"./g1.jpg": "1+Pv",
	"./g2.jpg": "6EVS",
	"./g3.jpg": "TR+l",
	"./g4.jpg": "gTxj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xKDF";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/items ^\.\/.*\.jpg$
// module id = xKDF
// module chunks = 1